<template>
  <div class="client-button_block">
    <div class="left">
      <ButtonWithDescriptionBox
        :link="{name: 'CreatingWork', params: null}"
        description="作図にかかる時間と必要なスキルなどを入力し、マッチングを待ちます。"
        button-name="新規発注"
        button-color="orange"/>
    </div>
    <div class="right">
      <ButtonWithDescriptionBox
        :link="{name: 'RetrievingWorks', params: null}"
        description="発注済みの案件のステータスがわかります。マッチングを待っている場合もこちらです。"
        button-name="案件一覧"
        button-color="yellow"/>
    </div>
  </div>
</template>

<script>
  import ButtonWithDescriptionBox from "@/components/molecules/box/button/ButtonWithDescriptionBox";

  export default {
    name: "OperatorButtonBlock",

    components: {ButtonWithDescriptionBox}
  }
</script>

<style lang="scss" scoped>
  .client-button_block {
    @include double_columns($left: 40%, $right: 40%);

    .button-with-description-box {
      margin-top: 2rem;
    }
  }
</style>
